import React from 'react'
import Modal from 'style-guide/component/Modal'
import Typography from 'style-guide/component/Typography';

interface IUpgradeModalProps {
  isOpen: boolean;
  onClose: () => void;
  handleBuyCredits: () => void;
  handleUpgradePlan: () => void;
}

const UpgradeModal : React.FC<IUpgradeModalProps> = ({isOpen,onClose,handleBuyCredits,handleUpgradePlan }) => {
  return (
    <Modal
    isOpen={isOpen}
    onClose={onClose}
    title="Choose Your Option"
    size="md"
    blurBackdrop
    footer={null}
  >
    <div className="space-y-4">
      <Typography variant="Base" text="What would you like to do?" />
      <div className="space-y-3">
        <div className="p-4 border border-gray-200 rounded-lg hover:border-blue-300 transition-colors cursor-pointer" onClick={handleBuyCredits}>
          <Typography variant="LG" text="Buy Credits" className="text-blue-primary font-medium" />
          <Typography variant="Base" text="Purchase additional credits to continue using our services" className="text-gray-600 mt-1" />
        </div>
        <div className="p-4 border border-gray-200 rounded-lg hover:border-blue-300 transition-colors cursor-pointer" onClick={handleUpgradePlan}>
          <Typography variant="LG" text="Upgrade Plan" className="text-blue-primary font-medium" />
          <Typography variant="Base" text="Upgrade to a higher tier plan with more features and credits" className="text-gray-600 mt-1" />
        </div>
      </div>
    </div>
  </Modal>
  )
}

export default UpgradeModal